import { isImmutable } from './isImmutable';

export function toJS<T extends object>(object: T | DeepIMap<T>): T {
  if (isImmutable(object)) {
    return object.toJS() as T;
  }

  return object;
}
